import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseCreateEstablishmentLeadContractProps {
  establishmentLeadId?: string
  payload?: object
  onSuccess?: () => void
  onError?: () => void
}

export const useCreateEstablishmentLeadContract = ({ establishmentLeadId, payload, onSuccess, onError }: UseCreateEstablishmentLeadContractProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['createEstablishmentLeadContract'],
    mutationFn: async () => {
      const lead = {
        contract_attributes: { _create: true, ...payload }
      }

      return privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}
